import ScrollToTop from './ScrollToTop';
import { HomeHeroProvider } from './HomeHeroContext';
import SiteHeader from './SiteHeader';

export default function Root({ children }) {
  return (
    <HomeHeroProvider>
      <ScrollToTop />
      <SiteHeader />
      {children}
    </HomeHeroProvider>
  );
}
